<template>
  <div class="video-board">
    <youtube-display />
    <stream-display />
    <video-display />
  </div>
</template>

<script>
import YoutubeDisplay from './youtube'
import StreamDisplay  from './stream'
import VideoDisplay   from './video-file'

export default {
  name: 'VideoBoard',
  data () {
    return {}
  },
  components: {
    YoutubeDisplay,
    StreamDisplay,
    VideoDisplay
  }
}
</script>

<style scoped>
.video-board {
  position : absolute;
  top      : 0;
  left     : 0;
  width    : 1920px;
  height   : 1080px;
}
</style>



// WEBPACK FOOTER //
// src/components/video/content/index.vue